import React, { Component } from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import firebase from "./services/firebaseConfig";
import { resetAmplitudeUser, setAmplitudeUser } from "./analytics";

class PrivateRoute extends Component {
  state = {
    haveAcces: false,
    loaded: false,
  };

  identifiedUid = null;

  componentDidMount() {
    this.checkAcces();
  }

  componentWillUnmount() {
    if (this.unsubscribeAuthStateChange) this.unsubscribeAuthStateChange();
  }

  checkAcces = () => {
    const { history } = this.props;

    this.unsubscribeAuthStateChange = firebase
      .auth()
      .onAuthStateChanged((user) => {
        if (user) {
          // Aqui, e não no submit do login: é por este caminho que passa quem
          // volta com sessão válida (F5, aba nova), que de outro jeito ficaria
          // anônimo no Amplitude.
          setAmplitudeUser(user);
          this.identifiedUid = user.uid;
          this.setState({ haveAcces: true, loaded: true });
        } else {
          // Chokepoint de todo signOut do admin, não só o do menu. Sem o reset,
          // os eventos de quem logar depois na mesma máquina continuariam
          // saindo com o user_id anterior.
          //
          // Só quando havia alguém identificado: este `else` cobre todo estado
          // de auth resolvido como nulo, e `amplitude.reset()` regenera o
          // device_id. Sem a guarda, cada abertura de um `/dashboard`
          // favoritado estando deslogado viraria um device anônimo novo.
          if (this.identifiedUid) {
            resetAmplitudeUser();
            this.identifiedUid = null;
          }
          history.push("/");
        }
      });
  };

  render() {
    const { component: Component, ...rest } = this.props;
    const { loaded, haveAcces } = this.state;
    if (!loaded) return null;
    return (
      <Route
        {...rest}
        render={(props) => {
          return haveAcces ? (
            <Component {...props} />
          ) : (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          );
        }}
      />
    );
  }
}

export default withRouter(PrivateRoute);
